export default function VenuePricing({
	showGuests,
	minSpendPerPerson,
	minSpendPricing,
	showVenueRental = false,
}) {
	return (
		<>
			{showGuests && (
				<div className="">
					<p className="text-primary font-medium">AED {minSpendPerPerson}</p>
					<p className="text-sm">Per guest</p>
				</div>
			)}

			{minSpendPricing && (
				<div className="">
					<p className="text-primary font-medium">AED {minSpendPricing}</p>
					{/* Show one "Min. spend" text */}
					<p className="text-sm">
						{" "}
						{showVenueRental ? "Venue rental" : "Min. spend"}
					</p>
				</div>
			)}
		</>
	);
}
